import React, { FC } from "react";
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalManager,
  ModalTitle,
} from "src/components/Modal";
import { Text } from "src/components/Text";
import { Button } from "src/components/Button";
import styled, { css } from "styled-components";
import { usePaymentMethodsDrawerState } from "./PaymentMethods.drawer.state";

const ListContainer = styled.ul`
  list-style: disc;
  padding: 0 ${(p) => p.theme.dimension.spacing.l}px;
`;

const ListContent = styled.li`
  ${(p) => css`
    padding: ${p.theme.dimension.spacing.s}px 0;
    line-height: ${p.theme.text.lineHeight.normal};
    font-size: ${p.theme.text.size.normal};
  `}
`;

type Props = {
  setShowDrawer: (showDrawer: boolean) => void;
  showDrawer: boolean;
};

export const PaymentMethodsDetailServiceFeeDrawer: FC<Props> = ({
  setShowDrawer,
  showDrawer,
}) => {
  const { detailServiceTranslate } = usePaymentMethodsDrawerState();

  return (
    <ModalManager
      modalSize="m"
      showModal={showDrawer}
      onClose={() => setShowDrawer(false)}
    >
      <Modal>
        <ModalHeader hideCloseIcon>
          <ModalTitle>{detailServiceTranslate("title")}</ModalTitle>
        </ModalHeader>
        <ModalContent>
          <ListContainer>
            {Array.isArray(detailServiceTranslate("content")) &&
              detailServiceTranslate("content").map(
                (content: string, index: number) => (
                  <ListContent key={index}>
                    <Text>{content}</Text>
                  </ListContent>
                )
              )}
          </ListContainer>
        </ModalContent>
        <ModalFooter>
          <Button onClick={() => setShowDrawer(false)}>
            {detailServiceTranslate("cta")}
          </Button>
        </ModalFooter>
      </Modal>
    </ModalManager>
  );
};
